// Constants
import {
  INTENTIONAL_NAVIGATION,
  INTENTIONAL_NAVIGATION_ON,
} from 'components/header-layout/constants/header-layout.constants';
// Types
import { SignedHandlersType } from './types/signed.handlers.type';
// Utilities
import { navigateToCallbackUrl } from 'utils/app-callback-url.utils';

const redirectAfterSignedHandler = (): void => {
  localStorage.setItem(INTENTIONAL_NAVIGATION, INTENTIONAL_NAVIGATION_ON);
  navigateToCallbackUrl();
};

const SignedHandlers = (): SignedHandlersType => ({
  handleRedirectAfterSigned: () => redirectAfterSignedHandler(),
});

export { SignedHandlers };
